// libraries
import { PostalCodeInput as InterstatePostalCodeInput } from '@interstate/components/PostalCodeInput';
import { withSelectOnFocus } from '../selectOnFocus/withSelectOnFocus';

/**
 * Thin pass-through wrapper over Interstate's PostalCodeInput that adds select-all
 * on focus (so a mouse click highlights the value the same way Tab does).
 * Toggle off => identical to the raw PostalCodeInput.
 */
export const PostalCodeInput = withSelectOnFocus(InterstatePostalCodeInput);

PostalCodeInput.displayName = 'PostalCodeInput';
